import { cn } from '@evolve/common-ui';
import React, { ReactNode } from 'react';
import { CheckboxInIcon, CheckboxOffIcon } from '../../../icons';

export type InputProps = {
  type?: any;
  field?: {
    id?: string;
    name?: string;
    onChange?: any;
    onBlur?: any;
    value?: any;
    disabled?: boolean;
    ref?: any;
    type?: string;
    placeholder?: string;
  };
  state?: {
    error?: any | undefined;
    invalid?: boolean;
    isTouched?: boolean;
    isFocused?: boolean;
    isLoading?: boolean;
    isDirty?: boolean;
  };
  isDisabled?: boolean;
};

type CheckboxProps = InputProps & {
  label: ReactNode;
  className?: string;
};

export function Checkbox({
  field,
  state,
  label,
  isDisabled,
  className,
}: CheckboxProps) {
  return (
    <div
      className={cn('flex flex-row gap-2', {
        'cursor-pointer': !isDisabled,
        '!cursor-not-allowed': isDisabled,
      })}
      onClick={() => {
        if (!isDisabled) {
          field?.onChange(!field?.value);
        }
      }}
    >
      <div className="flex min-w-[20px] flex-row gap-2">
        {field?.value ? <CheckboxInIcon /> : <CheckboxOffIcon />}
      </div>
      <label
        htmlFor={field?.name}
        className={cn('text-evolve-highlight leading-tight', {
          'cursor-pointer': !isDisabled,
        })}
      >
        {label}
      </label>
    </div>
  );
}

export function CheckboxInput({
  field,
  state,
  label,
  className,
  ...props
}: CheckboxProps) {
  const { error } = state ?? {};
  return (
    <div className={cn('flex flex-col', className)}>
      <Checkbox field={field} state={state} label={label} {...props} />
      {error && <span className="text-sm text-red-500">{error.message}</span>}
    </div>
  );
}

export default CheckboxInput;
